import { Menu, Transition } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { useCustomer } from '../../services/graph/hooks/useCustomer';
import strings from './pages.translations';
import { UserMenuLink } from './UserMenuLink';

export const UserMenu: FC = () => {
  const customer = useCustomer();

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="h-full flex items-center gap-2 text-right text-primary-800 font-bold">
        <div>
          <p className="leading-none">{customer.data?.name}</p>
          <p className="text-gray-500">{customer.data?.industry}</p>
        </div>
        <FiChevronDown className="h-6 w-6" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 rounded-md overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 flex flex-col">
          <UserMenuLink name={strings.userMenu.myDocuments} to="/documents/myDocuments" className="border-b" />
          <UserMenuLink name={strings.userMenu.logout} to="/auth/signout" />
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
